'use client'

import React from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import LogoButton from '@/components/logo'
import MixusLogo from '@/components/mixus-logo'

interface HeaderProps {
  className?: string
}

export function HeaderNotSignedInUser({ className }: HeaderProps) {


  const pathname = usePathname()

  // Show header on all /info paths, /public paths, /profile paths, and /pricing
  if (pathname && 
      !pathname.includes('/info') && 
      !pathname.includes('/public') && 
      !pathname.includes('/profile') && 
      !pathname.includes('/pricing')) {
    return null
  }

  return (
    <div className={cn(
      "flex items-center justify-between w-full h-12 px-2 sm:px-2 border-b shrink-0",
      "bg-mixus-soft-ivory dark:bg-mixus-dark-charcoal",
      "text-mixus-dark-charcoal dark:text-mixus-soft-ivory",
      "sticky top-0 left-0 right-0 z-50",
      "pt-safe-top",
      className
    )}>
      <div className="flex-1">
      </div>
      <div className="absolute left-1/2 transform -translate-x-1/2">
        <Link href="/">
          <MixusLogo/>
        </Link>
      </div>
      <div className="flex-1 flex justify-end">
        <Button variant="link" asChild
                className="text-black dark:text-white hover:text-gray-700 dark:hover:text-gray-300">
          <Link href="/sign-in">Sign-in</Link>
        </Button>
      </div>
    </div>
  )
}
